import React from 'react';
import { Row, Col, Table, Card } from 'reactstrap';
import CodeBlock from '../CodeBlock';
import { HashLink as Link } from 'react-router-hash-link';

function CandidateDetailsSection() {
    return (
        <section id="endpointscandidatedetails">
            <Row>
                <Col>
                    <h3>Candidate details endpoint</h3>
                    <p>
                        <code>GET</code> request to <code>/Candidate/{`{id}`}</code> returns the following response model.
                    </p>
                    <p>Optional request parameters:</p>
                    <p>
                        <code>/Candidate/123456?applicationsSince=01/01/2016&amp;includeCvPreview=true</code>
                    </p>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="applicationssince">applicationsSince</td>
                                <td>date</td>
                                <td>
                                    applicationsSince can be defined in following formats:
                                    <ul>
                                        <li>
                                            <code>dd/MM/yyyy</code>
                                        </li>
                                        <li>
                                            <code>d/M/yyyy</code>
                                        </li>
                                        <li>
                                            <code>yyyy-MM-dd</code>
                                        </li>
                                        <li>
                                            <code>yyyy-M-d</code>
                                        </li>
                                        <li>
                                            <code>dd/MM/yyyy HH:mm:ss</code>
                                        </li>
                                    </ul>
                                    default value is 90 days from now
                                </td>
                            </tr>
                            <tr>
                                <td>includeCvPreview</td>
                                <td>boolean</td>
                                <td>
                                    Specifies whether CvPreview property will be included in the response, default value is false.
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                    <Card className="bg-dark text-white" body>
                        <h4>Curl Example</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`curl -X GET \\\n'https://recruiter.totaljobs.com/CandidateSearchApi/Candidate/123456?applicationsSince=01%2F01%2F2016&includeCvPreview=true' \\\n-H 'authorization: bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiQ2FuZGlkYXRlIFNlYXJjaCBVc2VyIiwic2l0ZUlkIjoiNCIsInVuaXF1ZV9uYW1lIjoiMzM5MTc1YWQtMTEwNS00OWVkLTk3MzQtOTU0YzM5NzJjNTNjIiwiY2xpZW50SWQiOiIwMUQ0MzFCNy02REMwLTRERDEtQkYzMS0xRDQwNzlEMTI0QkEiLCJjbGllbnRVc2VySWQiOiJBIiwiaXNzIjoiUmVjcnVpdGVyIiwiYXVkIjoiYWxsIiwiZXhwIjoxNjE3MjcxODA3LCJuYmYiOjE2MTcyNzAwMDcsIlNzYVNlc3Npb25JZCI6ImNkODNjMTcyLThkZGUtNDEwNy1hNzRjLTY1NjlhMGU3YTQ2ZSJ9.gLBhEwpM5Ezh0PihC1ZCNdf4moZy2qNp1Y23NL_MYto' \\\n-H 'cache-control: no-cache'`}
                        </CodeBlock>
                        <h4>REQUEST HEADERS</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`Authorization: bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiQ2FuZGlkYXRlIFNlYXJjaCBVc2VyIiwic2l0ZUlkIjoiNCIsInVuaXF1ZV9uYW1lIjoiMzM5MTc1YWQtMTEwNS00OWVkLTk3MzQtOTU0YzM5NzJjNTNjIiwiY2xpZW50SWQiOiIwMUQ0MzFCNy02REMwLTRERDEtQkYzMS0xRDQwNzlEMTI0QkEiLCJjbGllbnRVc2VySWQiOiJBIiwiaXNzIjoiUmVjcnVpdGVyIiwiYXVkIjoiYWxsIiwiZXhwIjoxNjE3MjcxODA3LCJuYmYiOjE2MTcyNzAwMDcsIlNzYVNlc3Npb25JZCI6ImNkODNjMTcyLThkZGUtNDEwNy1hNzRjLTY1NjlhMGU3YTQ2ZSJ9.gLBhEwpM5Ezh0PihC1ZCNdf4moZy2qNp1Y23NL_MYto\nContent-Type: application/json`}
                        </CodeBlock>
                        <h4>RESPONSE HEADERS</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`content-type: application/json; charset=utf-8\nstatus: 200 OK`}
                        </CodeBlock>
                        <h4>RESPONSE BODY</h4>
                        <CodeBlock langauge="json" theme="dark">
                            {`{\n\t"Id": 123456,\n\t"ForeName": "John",\n\t"Surname": "Doe",\n\t"DesiredJobTitle": "1st line support",\n\t"CurrentJobTitle": "IT Service Desk Analyst",\n\t"WorkExperience": "Over 20 years",\n\t"Title": "Mr",\n\t"PersonalSummary": "A highly motivated and hardworking individual, who has recently...",\n\t"KeySkills": "Quick learner,MS Office,Windows XP,Windows 7,Windows 10,Windows Server,computer hardware",\n\t"LandlinePhone": "1234567890",\n\t"MobilePhone": "1234567890",\n\t"Email": "example@email.com",\n\t"IsAnonymous": false,\n\t"WebsiteLinks": [\n\t\t{\n\t\t\t"Url": "https://www.linkedin.com/in/john-doe-12345",\n\t\t\t"Type": "linkedin"\n\t\t}\n\t],\n\t"DesiredLocations": [\n\t\t"London"\n\t],\n\t"CurrentSalary": {\n\t\t"LowerValue": 104,\n\t\t"UpperValue": 111,\n\t\t"RateType": "Day"\n\t},\n\t"DesiredSalary": {\n\t\t"LowerValue": 24000,\n\t\t"UpperValue": 25999,\n\t\t"RateType": "Year"\n\t},\n\t"LastUpdatedDate": "08/01/2021 00:00:00",\n\t"LastApplicationDate": "08/01/2021 00:00:00",\n\t"ApplicationsData": {\n\t\t"Count": 24,\n\t\t"Since": "08/01/2021 00:00:00"\n\t},\n\t"ViewInfo": {\n\t\t"ViewDate": "08/04/2021 08:05:45",\n\t\t"ViewedBy": "Me",\n\t\t"UpdatedSinceViewed": false\n\t},\n\t"Languages": [],\n\t"JobTypes": [\n\t\t"Permanent"\n\t],\n\t"Residence": "UK",\n\t"EducationLevel": "GCSE/GNVQ/O levels",\n\t"JobHour": "Full Time",\n\t"CvPreview": "<html>Their CV in HTML</html>",\n\t"LastActiveDate": "08/04/2021 07:12:42",\n\t"RegisteredDate": "06/04/2015 18:23:55"\n}`}
                        </CodeBlock>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col>
                    <h3 id="candidateresponsemodel">Response model</h3>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Id</td>
                                <td>integer</td>
                                <td>Our internal identifier for given candidate.</td>
                            </tr>
                            <tr>
                                <td>ForeName</td>
                                <td>string</td>
                                <td>Candidates first name.</td>
                            </tr>
                            <tr>
                                <td>Surname</td>
                                <td>string</td>
                                <td>Candidates last name.</td>
                            </tr>
                            <tr>
                                <td>DesiredJobTitle</td>
                                <td>string</td>
                                <td>Candidates requested job title.</td>
                            </tr>
                            <tr>
                                <td>CurrentJobTitle</td>
                                <td>string</td>
                                <td>Candidates current job title.</td>
                            </tr>
                            <tr>
                                <td>WorkExperience</td>
                                <td>string</td>
                                <td>Duration of time spent in current job title.</td>
                            </tr>
                            <tr>
                                <td>Title</td>
                                <td>string</td>
                                <td>Candidates title.</td>
                            </tr>
                            <tr>
                                <td>PersonalSummary</td>
                                <td>string</td>
                                <td>Candidates personal summary.</td>
                            </tr>
                            <tr>
                                <td>KeySkills</td>
                                <td>string</td>
                                <td>List of skills extracted from candidates&apos; profile and CV.</td>
                            </tr>
                            <tr>
                                <td>LandlinePhone</td>
                                <td>string</td>
                                <td>Candidate phone number.</td>
                            </tr>
                            <tr>
                                <td>MobilePhone</td>
                                <td>string</td>
                                <td>Candidate mobile number.</td>
                            </tr>
                            <tr>
                                <td>Email</td>
                                <td>string</td>
                                <td>Candidates provided email address.</td>
                            </tr>
                            <tr>
                                <td>IsAnonymous</td>
                                <td>boolean</td>
                                <td>
                                    This flag informs that candidate profile is anonymised. Information like FirstName, LastName,
                                    Phone and Email are not being returned. <code>CV preview</code> and <code>Download CV</code>{' '}
                                    options are not available for such candidates.
                                </td>
                            </tr>
                            <tr>
                                <td>WebsiteLinks</td>
                                <td>object array</td>
                                <td>
                                    Returns an array of <Link to="#websitelink">WebsiteLink</Link> objects.
                                </td>
                            </tr>
                            <tr>
                                <td>DesiredLocations</td>
                                <td>string array</td>
                                <td>Candidates&apos; selected list of desired job locations.</td>
                            </tr>
                            <tr>
                                <td>CurrentSalary</td>
                                <td>object</td>
                                <td>
                                    Returns a <Link to="#candidatesalaryresponse">CandidateSalary</Link> object.
                                </td>
                            </tr>
                            <tr>
                                <td>DesiredSalary</td>
                                <td>object</td>
                                <td>
                                    Returns a <Link to="#candidatesalaryresponse">CandidateSalary</Link> object.
                                </td>
                            </tr>
                            <tr className="table-danger">
                                <td>LastUpdatedDate (Obsolete)</td>
                                <td>date</td>
                                <td>
                                    This has been replaced by <Link to="#lastactivedatecandidate">LastActiveDate</Link> and will
                                    always display the value of <Link to="#lastactivedatecandidate">LastActiveDate</Link>.
                                </td>
                            </tr>
                            <tr className="table-danger">
                                <td>LastApplicationDate (Obsolete)</td>
                                <td>date</td>
                                <td>
                                    This has been replaced by <Link to="#lastactivedatecandidate">LastActiveDate</Link> and will
                                    always display the value of <Link to="#lastactivedatecandidate">LastActiveDate</Link>. dd/MM/yyyy
                                    HH:mm:ss If the candidate has requested their application data be hidden then the endpoint will
                                    return no data.
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Link to="#applicationsdata">ApplicationsData</Link>
                                </td>
                                <td>object</td>
                                <td>
                                    If the candidate has requested their application data be hidden then the endpoint will return no
                                    data.
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Link to="#viewinfo">ViewInfo</Link>
                                </td>
                                <td>object</td>
                                <td>Object containing recruiter viewing data on this candidate.</td>
                            </tr>
                            <tr>
                                <td>JobType</td>
                                <td>string array</td>
                                <td>
                                    Candidates requested job type as defined by the values outlined by the dictionary endpoint{' '}
                                    <code>/Dictionary/JobTypes</code>.
                                </td>
                            </tr>
                            <tr>
                                <td id="lastactivedatecandidate">LastActiveDate</td>
                                <td>date</td>
                                <td>
                                    dd/MM/yyyy HH:mm:ss The date of their latest application or profile update date, which ever is the
                                    most recent.
                                </td>
                            </tr>
                            <tr>
                                <td>RegisteredDate</td>
                                <td>date</td>
                                <td>dd/MM/yyyy HH:mm:ss When the candidate registered their profile.</td>
                            </tr>
                            <tr>
                                <td>JobHour</td>
                                <td>string</td>
                                <td>Type of hours candidate wishes to work.</td>
                            </tr>
                            <tr>
                                <td>Languages</td>
                                <td>string array</td>
                                <td>List of languages selected by candidate.</td>
                            </tr>
                            <tr>
                                <td>Educationallevel</td>
                                <td>string</td>
                                <td>Highest level of education.</td>
                            </tr>
                            <tr>
                                <td>Residence</td>
                                <td>string</td>
                                <td>Country of residence.</td>
                            </tr>
                            <tr>
                                <td>CvPreview</td>
                                <td>string</td>
                                <td>
                                    HTML string of candidate CV, Included only when includeCvPreview parameter is set to true (for
                                    non-anonymous candidates).
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </section>
    )
}

export default CandidateDetailsSection
